import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorUsersState = (state: RootState) => state.users;

export const selectorUserProfileCard = createSelector(
  selectorUsersState,
  (usersState) => usersState.userProfileCard
);

export const selectorUserProfileInfo = createSelector(
  selectorUsersState,
  (usersState) => usersState.userProfileInfo
);

export const selectorUserProfileClones = createSelector(
  selectorUsersState,
  (usersState) => usersState.clones
);

export const selectorUserProfileInquiries = createSelector(
  selectorUsersState,
  (usersState) => usersState.inquiries
);
